/* NOWi homepage v2: scroll reveals, count-ups, chart drawing, solution tabs and the leak cost estimator. */
(function () {
  if (window.__nv2) return;
  window.__nv2 = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Analytics: send to GA4 through the gtag the Shopify Google app loads (same pattern as the GTM
  // click-tracking tag), plus a Shopify customer event for custom pixels.
  var GA = 'G-Q1086YFBY7';
  function track(name, params) {
    params = params || {};
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('nowi_' + name, params); } catch (e) {}
    // gtag can load after this script, so an event fired on page load waits for it (up to 10 s).
    (function send(tries) {
      if (typeof window.gtag === 'function') {
        try { window.gtag('event', name, Object.assign({ send_to: GA }, params)); } catch (e) {}
      } else if (tries < 20) {
        setTimeout(function () { send(tries + 1); }, 500);
      }
    })(0);
  }

  function onVisible(els, cb, opts) {
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { cb(el); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { io.unobserve(e.target); cb(e.target); }
      });
    }, opts || { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  // Count a number up from zero, keeping its prefix, separators and suffix ("$190,000", "72%", "< 2 mo").
  function countUp(el) {
    var raw = el.getAttribute('data-count-text') || el.textContent;
    var m = raw.match(/^([^0-9]*)([0-9][0-9,]*(?:\.[0-9]+)?)(.*)$/);
    if (!m || reduce) return;
    var target = parseFloat(m[2].replace(/,/g, ''));
    if (!isFinite(target) || target < 10) return;
    var decimals = (m[2].split('.')[1] || '').length;
    var useComma = m[2].indexOf(',') > -1 || target >= 10000;
    var start = null, dur = 1400;
    function fmt(v) {
      var s = v.toFixed(decimals);
      if (useComma) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return m[1] + s + m[3];
    }
    function step(t) {
      if (start === null) start = t;
      var p = Math.min(1, (t - start) / dur);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(target * e);
      if (p < 1) requestAnimationFrame(step); else el.textContent = raw;
    }
    el.textContent = fmt(0);
    requestAnimationFrame(step);
  }

  function initReveals(root) {
    root.querySelectorAll('[data-stagger]').forEach(function (group) {
      var kids = group.querySelectorAll(':scope > [data-reveal]');
      kids.forEach(function (k, i) { k.style.setProperty('--d', (i * 0.09).toFixed(2) + 's'); });
    });
    onVisible(Array.prototype.slice.call(root.querySelectorAll('[data-reveal]')), function (el) { el.classList.add('is-in'); });
    onVisible(Array.prototype.slice.call(root.querySelectorAll('[data-count]')), countUp, { threshold: 0.6 });
    var charts = Array.prototype.slice.call(root.querySelectorAll('.nv2-draw'));
    charts.forEach(function (svg) {
      svg.querySelectorAll('path.nv2-line').forEach(function (p) {
        try { p.style.setProperty('--len', Math.ceil(p.getTotalLength()) + 1); } catch (e) {}
      });
    });
    onVisible(charts, function (el) { el.classList.add('is-in'); }, { threshold: 0.35 });
  }

  function initTabs(root) {
    root.querySelectorAll('[data-nv2-tabs]').forEach(function (box) {
      var tabs = Array.prototype.slice.call(box.querySelectorAll('[role="tab"]'));
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (!panel) return;
          if (on) {
            panel.hidden = false;
            panel.classList.remove('is-in');
            void panel.offsetWidth;
            panel.classList.add('is-in');
          } else {
            panel.hidden = true;
          }
        });
        if (focus) tab.focus();
        if (window.innerWidth < 750) tab.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
    });
  }

  function initEstimator(root) {
    root.querySelectorAll('[data-nv2-est]').forEach(function (form) {
      var leaks = Array.prototype.slice.call(form.querySelectorAll('[name="leak"]'));
      var rate = form.querySelector('[name="rate"]');
      var days = form.querySelector('[name="days"]');
      var out = {};
      ['bill', 'nowi', 'gal', 'days', 'saved', 'rate', 'bar'].forEach(function (k) { out[k] = form.querySelector('[data-out="' + k + '"]'); });
      var money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
      var num = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });
      function picked() { for (var i = 0; i < leaks.length; i++) if (leaks[i].checked) return leaks[i]; return leaks[0]; }
      function values() {
        return {
          g: Math.max(0, parseFloat(picked().value) || 0),
          r: Math.max(0, parseFloat(rate.value) || 0),
          d: Math.max(1, Math.min(365, parseFloat(days.value) || 1))
        };
      }
      function set(k, text) { if (out[k]) out[k].textContent = text; }
      function calc() {
        var v = values();
        var bill = v.g * v.r / 1000 * v.d;
        var nowi = v.g * v.r / 1000;
        set('bill', money.format(bill));
        set('nowi', money.format(nowi));
        set('saved', money.format(bill - nowi));
        set('gal', num.format(v.g * (v.d - 1)));
        set('days', num.format(v.d));
        set('rate', String(v.r));
        if (out.bar) out.bar.style.width = Math.max(3, 100 / v.d) + '%';
      }
      form.addEventListener('input', calc);
      form.addEventListener('change', calc);
      form.addEventListener('submit', function (e) { e.preventDefault(); });
      calc();

      function snapshot() {
        var v = values();
        return { leak_type: picked().getAttribute('data-key') || picked().value, leak_gal_per_day: Math.round(v.g), water_rate: v.r, days_to_notice: v.d,
          cost_without_nowi: Math.round(v.g * v.r / 1000 * v.d), cost_with_nowi: Math.round(v.g * v.r / 1000), currency: 'USD' };
      }
      onVisible([form], function () { track('estimator_view', snapshot()); }, { threshold: 0.4 });
      var started = false, timer = null, sent = 0;
      function used() {
        if (!started) { started = true; track('estimator_start', snapshot()); }
        clearTimeout(timer);
        timer = setTimeout(function () { if (sent < 20) { sent++; track('estimator_calculate', snapshot()); } }, 1500);
      }
      form.addEventListener('input', used);
      leaks.forEach(function (l) { l.addEventListener('change', function () { used(); track('estimator_leak_select', snapshot()); }); });
      var cta = form.querySelector('[data-nv2-cta]');
      if (cta) cta.addEventListener('click', function () { track('estimator_cta_click', snapshot()); });
    });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#nv2-estimate"]');
    if (a) track('estimator_open', { source: a.getAttribute('data-nv2-source') || 'link' });
  });

  // Benchmark study signup. Shopify reloads the page after the customer form posts,
  // so the submit sets a flag and the reloaded page reports the signup once.
  function initGuide(root) {
    var form = root.querySelector('#nv2-guide-form');
    if (!form) return;
    form.addEventListener('submit', function () {
      try { sessionStorage.setItem('nv2_guide', '1'); } catch (e) {}
    });
    if (form.querySelector('[data-nv2-guide-ok]')) {
      var sent = false;
      try { sent = sessionStorage.getItem('nv2_guide') === '1'; sessionStorage.removeItem('nv2_guide'); } catch (e) {}
      if (sent) track('guide_signup', { source: 'homepage' });
    }
    var dl = form.querySelector('[data-nv2-guide-dl]');
    if (dl) dl.addEventListener('click', function () { track('guide_download', { source: 'homepage' }); });
  }

  function init() {
    document.querySelectorAll('.nv2').forEach(function (root) {
      if (root.__nv2) return;
      root.__nv2 = true;
      initReveals(root);
      initTabs(root);
      initEstimator(root);
      initGuide(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Theme editor: re-run when a section is added or changed.
  document.addEventListener('shopify:section:load', function () { init(); });
})();
